import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_BILLING_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => ({
    ...oldDoc,
    programId: null,
    renderingProviderUserId: null,
  }),
  2: (oldDoc) => oldDoc,
};
